import Grid from '@mui/material/Grid';
import Drawer from 'components/Drawer';
import ProductsTable from 'pages/Products/FlowProducts/ProductsTable';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { groupBy } from 'selectors/generic';
import StepProductSelector from './StepProductSelector';

// `flow.steps` used to arrive nested inside the flowchart; it is the steps
// slice keyed by flow_id - substeps included, since they carry the flow too.
const stepsByFlow = groupBy('steps', 'flow_id');

// Same as /flow-steps-rm: an account with no flowcharts is a legitimate state, and this page reached
// into flows.models[flowId] before drawing anything. The check sits outside the hooks for the same
// reason it does there.
const NoFlows = () => (
  <Grid size={12}>
    <p>Ainda não há fluxogramas nesta conta. Crie um em Fluxogramas para poder associar-lhe produtos.</p>
  </Grid>
);

const Component = props =>
  props.flows.data.length ? <FlowProducts {...props} /> : <NoFlows />;

const FlowProducts = props => {
  const { flows, stepsOfFlow, stepsById } = props;

  const [productId, setProductId] = useState(null);
  const [flowId, setFlowId] = useState(flows.data[0].id);
  const handleCloseDrawer = () => setProductId(null);

  const flowSteps = stepsOfFlow[flowId] || [];
  // Generates flowSteps with aditional data for Table in StepProductSelector
  const flowStepsEnhanced = flowSteps.map( fs => {
    if (!fs.master_step_id) {
      return { ...fs, step_name: fs.name, step_description: fs.description };
    } else {
      const masterStep = stepsById[fs.master_step_id];
      return {
        ...fs,
        step_name: masterStep.name,
        step_description: masterStep.description,
        substep_name: fs.name,
        substep_description: fs.description
      };
    }
  });

  return (
    <Grid size={12}>
      <ProductsTable
        flowId={flowId}
        setFlowId={setFlowId}
        setProductId={setProductId}
      />
      {
        productId &&
        <Drawer open={true} onClose={handleCloseDrawer}>
          <StepProductSelector
            productId={productId}
            flowId={flowId}
            flowSteps={flowStepsEnhanced}
            handleCloseDrawer={handleCloseDrawer}
          />
        </Drawer>
      }
    </Grid>
  );
};

const mapStateToProps = (state, props) => ({
  flows: state.flows,
  stepsOfFlow: stepsByFlow(state),
  stepsById: state.steps.models
});

export default connect(mapStateToProps)(Component);
